let date = new Date();
let day = date.getDate();
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
let exactmonth = months[date.getMonth()];
let exactDay = day.toString().padStart(2, "0");
let year = date.getFullYear();
let hrs = date.getHours();
let mnuts = date.getMinutes();
let secnd = date.getSeconds();

export const GetDateFormat= ()=>{
    return `${exactDay}${exactmonth}${year}`;
};
export const newGetDateFormat= ()=>{
    return `${exactDay}${exactmonth}${year}${hrs}${mnuts}${secnd}`;
};

export const GetDateFormatTime = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
      
    const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const time = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
      
    return `${date}_${time}`;
};